/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const subtitleEntrySchema = z.object({
  index: z.number(),
  startMs: z.number(),
  endMs: z.number(),
  startTimestamp: z.string(),
  endTimestamp: z.string(),
  text: z.string(),
});

export type ISubtitleEntry = z.infer<typeof subtitleEntrySchema>;
